// @flow
import React from "react";
import classNames from "classnames";
import { withGlobalContext } from "../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";

import ContactInfo from "./ThreeCol/ContactInfo";
import OfficeInfo from "./ThreeCol/OfficeInfo";
import Copyright from "./Copyright";
import AgentSocial from "../../agent-detail/AgentSocial";

import type { $Agent, $Site, $Team } from "flow/types";

type $Props = {
  agent: $Agent,
  site: $Site,
  classes: Object,
  team: $Team,
};

const ThreeCol = ({ agent, team, site, classes }: $Props) => {
  let socialMedia;
  if (agent) {
    ({ socialMedia } = agent);
  } else if (team) {
    ({ socialMedia } = site);
  }
  return (
    <footer id="site-footer" className={classes.root}>
      <div className={classes.container}>
        <div className={classNames(classes.column, classes.officeInfo)}>
          {site.officeId ? <OfficeInfo /> : <ContactInfo />}
          {socialMedia && (
            <AgentSocial className={classes.social} socialMedia={socialMedia} />
          )}
        </div>
        {!site.officeId && (
          <div className={classes.column}>
            <OfficeInfo />
          </div>
        )}
        <div className={classes.column}>
          <Copyright />
        </div>
      </div>
      <div className={classes.google}>
        <div id="google_translate_element" />
      </div>
    </footer>
  );
};

const styles = (theme) => {
  return {
    root: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      margin: "0",
      padding: "32px 0 40px",
      width: "100%",
      backgroundColor: theme.colors.primary["500"],
    },
    container: {
      display: "flex",
      flexFlow: "row wrap",
      justifyContent: "space-between",
      alignItems: "flex-start",
      width: "100%",
      maxWidth: "1170px",
    },
    column: {
      flex: "1 1 33%",
      padding: "0 15px",
      textAlign: "center",
      color: theme.colors.primaryFontColor,
      "& p": {
        maxWidth: "100%",
      },
    },
    social: {
      justifyContent: "center",
      margin: "12px auto",
      textAlign: "center",
      "& a": {
        color: `${theme.colors.primaryFontColor} !important`,
      },
    },
    google: {
      marginTop: theme.spacing.unit * 1.5,
    },
    officeInfo: {
      display: "flex",
      justifyContent: "center",
      flexFlow: "wrap",
      "& > div": {
        padding: `0 ${theme.spacing.unit * 1.5}px ${theme.spacing.unit *
          1.5}px ${theme.spacing.unit * 1.5}px`,
      },
    },
  };
};

export default withGlobalContext(withStyles(styles)(ThreeCol));
